import React, { Fragment } from "react";
// import debug from "../debug";
import { LabelStyle } from "../types";

// const log = debug("SvgConnector");

interface Props {
    fromX: number;
    fromY: number;
    toX: number;
    toY: number;
    heightL: number;
    heightR: number;
    paddingY: number;
    lineX: number;
    styleFrom: LabelStyle;
    styleTo: LabelStyle;
    onClick: () => void;
    onMouseEnter: (event: React.MouseEvent) => void;
    onMouseLeave: (event: React.MouseEvent) => void;
}

const MIN_HEIGHT = 5;
const SvgConnector: React.FC<Props & any> = function ({
    fromX,
    fromY,
    toX,
    toY,
    heightL,
    heightR,
    paddingY,
    lineX,
    styleFrom,
    styleTo,
    onClick,
    onMouseEnter,
    onMouseLeave,
    ...props
}: Props) {
    const paddingYL = heightL - paddingY * 2 > MIN_HEIGHT ? paddingY : Math.max(0, heightL - MIN_HEIGHT) * 0.5;
    const paddingYR = heightR - paddingY * 2 > MIN_HEIGHT ? paddingY : Math.max(0, heightR - MIN_HEIGHT) * 0.5;
    const padding = Math.min(paddingYL, paddingYR);

    let dX = toX - fromX;
    const dY = toY - fromY;
    const dH = heightR - heightL;

    // const midX = fromX + dX * 0.5;
    // const midY = fromY + paddingYL + dY * 0.5;

    dX -= 2 * lineX;
    const dX2 = dX * 0.5;

    const fillKey = `lfill_${styleFrom.var_name}_${styleTo.var_name}`;
    const fill = `url('#${fillKey}')`;

    //
    // svg path editor - good for debugging
    // https://yqnn.github.io/svg-path-editor/
    //
    return (
        <Fragment>
            {/* <text className={styles.text} x={midX} y={midY}>
                {height}
            </text> */}

            <path
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                d={`M ${fromX} ${fromY + padding} l ${lineX} 0 c ${dX2} 0, ${dX2} ${dY}, ${dX} ${dY} l ${lineX} 0 l 0 ${
                    heightR - padding * 2
                } l -${lineX} 0 c ${-dX2} 0, ${-dX2} ${-dY - dH}, ${-dX} ${-dY - dH} l -${lineX} 0 Z`}
                stroke={fill}
                fill={fill}
                {...props}
            />
        </Fragment>
    );
};

export default SvgConnector;

// const Connector: React.FC<ConnectorProps> = function ({
//     fromX,
//     fromY,
//     toX,
//     toY,
//     height,
//     styleFrom,
//     styleTo,
//     ...props
// }: ConnectorProps) {
//     const dX4 = (toX - fromX) / 4;
//     const dY4 = (toY - fromY) / 4;

//     const fillKey = `lfill_${styleFrom.var_name}_${styleTo.var_name}`;

//     return (
//         <Fragment {...props}>
//             <text className={styles.text} x={fromX + dX4 * 2} y={fromY + dY4 * 2}>
//                 {height}
//             </text>

//             <path
//                 d={`M ${fromX} ${fromY + height * 0.5} c ${dX4} 0, ${dX4} 0, ${dX4 * 2} ${dY4 * 2} s ${dX4} ${
//                     dY4 * 2
//                 }, ${dX4 * 2} ${dY4 * 2}`}
//                 // stroke={`url(#${fillKey})`}
//                 stroke={styleTo.colorInactive}
//                 strokeWidth={height}
//                 fill="transparent"
//             />
//         </Fragment>
//     );
// };
